import clsx from 'clsx';
import { type ComponentProps, useEffect, useState } from 'react';

import styles from './inline-input.module.scss';

export const InlineInput = (props: InlineInputProps) => {
  const { value = '', placeholder = 'Untitled', className, onChange, ...rest } = props;

  const [internalValue, setInternalValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);

  // Sync from props only when not focused (external updates / switching docs)
  useEffect(() => {
    if (!isFocused) {
      setInternalValue(value);
    }
  }, [value, isFocused]);

  return (
    <div className={clsx(styles.inlineInput, className, 'inline-input')} data-value={internalValue || placeholder}>
      <input
        size={1}
        type="text"
        value={internalValue}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={(e) => {
          setInternalValue(e.target.value);
          onChange?.(e);
        }}
        placeholder={placeholder}
        className={clsx('ellipsis-text')}
        {...rest}
      />
    </div>
  );
};

export interface InlineInputProps extends ComponentProps<'input'> {}
